module.exports = __webpack_public_path__ + "static/media/banner-bowling.d05a9906.jpg";